export const figure18g = {
  chart: {
      type: 'line',
      backgroundColor: 'rgba(255, 255, 255, 0.0)',
        height: 230,
      plotBackgroundColor: null,
      plotBorderWidth: null,
    },
    credits: {
      enabled: false
  },
    title: {
      text: 'Ouganda'
    },
    subtitle: {
      text: null
  },
    xAxis: {
      categories: ['2010','2011','2012', '2014', '2016','2020',]
    },
    labels: {
      	
      style: {
        fontWeight: 'normal',
        color: '#999999',
        fontSize: '12px'
      },
    },
    yAxis: {
      min: 0,
      max: 2000,
      tickInterval: 500,
      title: {
          text: null,
      },
    },
    plotOptions: {
      line: {
        dataLabels: {
          enabled: false
        },
        enableMouseTracking: true
      }
    },
    legend: {
      enabled: false,
  },
    colors: ['#5b9bd5', '#ed7d32','#cbcccb', '#ffc100'],
    series: [{
      name: 'Petites exploitations',
      data: [687, 717, 746, 686, 612, 716,]
    }, {
      name: 'Autres exploitations',
      data: [1271, 1363, 1300, 1753, 1073, 1188,]
    },{
      name: 'Petites exploitations dirigées par une femme',
      data: [578, 650, 624, 598, 576, 606,]
    },{
      name: 'Petites exploitations dirigées par un homme',
      data: [733, 750, 815, 739, 633, 781,]
    }]
  }

  